import { ExecuteJavascriptWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ExecuteJavascript')
export class ExecuteJavascriptConnectorProvider extends ConnectorProvider<ExecuteJavascriptWorkflowNode> {}
